// @ts-nocheck: converted from JS

export const observationFiltersToTitle = {
  value: 'Score',
  animal: 'Animal',
  study_group: 'Study group',
  cage: 'Cage',
  team_glossary_api_id: 'Observation',
  observed_at: 'Date',
};
